/* eslint-disable react/jsx-props-no-spreading -- wrappers here forward props wholesale */
import _ from 'lodash';
import React, { Fragment } from 'react';

const GroupedResult = ({ result, resultComponent, grouping, showLogo = false }) => {
  const groups = _.groupBy(result.data, grouping?.key);
  const GroupComponent = grouping?.component;
  const groupSort = grouping?.sort || ((a, b) => b.toString().localeCompare(a.toString()));
  const Component = resultComponent;
  return (
    <>
      {Object.entries(groups)
        .sort(([groupKey1, groupValue1], [groupKey2, groupValue2]) => groupSort(groupKey1, groupKey2))
        .map(([groupKey, groupValue]) => (
          <GroupComponent
            key={groupKey}
            groupKey={groupKey}
            title={groupValue.length > 1 ? `${grouping.title}s` : grouping.title}
          >
            {groupValue.map(item => (
              <Component key={item.list_number} {...item} showLogo={showLogo} />
            ))}
          </GroupComponent>
        ))}
    </>
  );
};

export default GroupedResult;
